import Vue from "vue"
import App from "./App.vue"
import vuexI18n from "vuex-i18n"

import router from "./router"
import store from "./store/store"
import ApiService from "./services/ApiService"
import ListsModel from "./models/listsModel"
import CalculationFormulas from "./helpers/calculationformulas"
import LKPKannattavuuslaskuriModel from "./models/lkpKannattavuuslaskuriModel"
import { defineCustomElements } from "@duetds/date-picker/dist/loader"
import { DuetDatePicker } from "@duetds/date-picker/custom-element"

Vue.use(vuexI18n.plugin, store)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/duet-\w*/]
defineCustomElements(window)
customElements.define("duet-date-picker", DuetDatePicker)

new Vue({
    router,
    store,
    render: h => h(App),
    data: {
        apiService: new ApiService("/AutoilijanPalvelut")
    },

    async created() {
        // asetetaan kהyttהjהn kieli query-parametrin perusteella
        const allowedLanguages = ["fi", "sv", "en"]

        let langID = "fi"
        for (const item in this.$route.query) {
            if (item.toLocaleLowerCase() === "langid" && allowedLanguages.includes((this.$route.query[item] as string).toLocaleLowerCase())) {
                langID = (this.$route.query[item] as string).toLocaleLowerCase()
            }
        }
        this.$store.dispatch("setLang", langID)

        this.$store.dispatch("setLoading", true)
        this.$store.dispatch("setBaseHref", "/AutoilijanPalvelut")

        this.apiService.GetConfigValuesForLists().then(response => {
            const listModel: ListsModel = new ListsModel(response.VehicleTypes, response.FuelTypes, response.CO2MeasureTypes, response.AxelAmounts, response.TrailerTypes)
            this.$store.dispatch("setAjoneuvoverolaskuriLists", listModel)
        }).finally(() => {
            // Populoidaan map-objektit traficomin luvuilla
            this.$store.dispatch("setNedcMap", CalculationFormulas.populateNedcMap())
            this.$store.dispatch("setNedcMapPost2025", CalculationFormulas.populateNedcMapPost2025())
            this.$store.dispatch("setWltpMap", CalculationFormulas.populateWltpMap())
            this.$store.dispatch("setWltpMapPost2025", CalculationFormulas.populateWltpMapPost2025())
        })

        this.apiService.GetLKPKannattavuusLaskuriConfigs().then(response => {
            const lkpConfigs: LKPKannattavuuslaskuriModel = new LKPKannattavuuslaskuriModel(response.Office, response.Internet)
            this.$store.dispatch("setLKPLaskuriConfigs", lkpConfigs)
        })

        this.apiService.getConfigValues().then(response => {
            this.$store.dispatch("setContentServiceUrl", response.contentServiceUrl)
        }).finally(() => {
            Vue.i18n.set(this.$store.getters.activeLang)

            this.apiService.getLanguageTerms().then(response => {
                Vue.i18n.add("fi", response.fi)
                Vue.i18n.add("sv", response.sv)
                Vue.i18n.add("en", response.en)

                // Kun MapServicesUrlLoading bitti asetetaan false, ryhdytään karttaa ja filttereitä alustamaan.
                this.$store.dispatch("setLoading", false)
                this.$store.dispatch("setMainLoaded", true)
            })
        })
    }

}).$mount("#app")
